import React, { useEffect, useState } from 'react';
import { CollapseBlock, Spinner } from '../../../../common';
import { ReloadOutlined } from '@ant-design/icons';
import { useGetUsersQuery } from '../../../../../redux/services/users';
import UsersTable from './UsersTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import usePermission from '../../../../../hooks/usePermission';
import LDAPSynchronizationModal from '../../LDAP/Modals/LDAPSynchronizationModal.jsx';

const UsersPages = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canEditRoles = usePermission('users-admin');
  const canOpenLdapSync = usePermission('ldap-sync');
  const [isLdapModalOpen, setIsLdapModalOpen] = useState(false);

  const { data: users, isLoading } = useGetUsersQuery({
    view: 'usersTable',
  });

  useEffect(() => {
    document.title = t('Používatelia FRI') + ' - FRI CMS';
  }, []); // Runs on mount

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Používatelia FRI')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        permissionsBasic={'users'}
        mainActions={[
          {
            onClick: () => setIsLdapModalOpen(true),
            title: t('LDAP synchronizácia'),
            icon: <ReloadOutlined />,
            permission: 'ldap-sync',
          },
        ]}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <UsersTable
            users={users}
            onEditUserProfileClick={(id) =>
              navigate(`${routes.cmsUserProfileEdit}/${id}`)
            }
            onDetailClick={(id) => navigate(`${routes.cmsUsersEdit}/${id}`)}
            showRolesEditIcon={canEditRoles}
          />
        </CollapseBlock>
      </div>

      {canOpenLdapSync && (
        <LDAPSynchronizationModal
          open={isLdapModalOpen}
          onClose={() => setIsLdapModalOpen(false)}
        />
      )}
    </>
  );
};

export default UsersPages;
